export interface MarginNotesSlice {
    marginNotes: string | null;
}

export const initialMarginNotesSlice: MarginNotesSlice = {
    marginNotes: null
};
